import type {RouteRecordRaw} from 'vue-router';
import {useServiceAccount} from '@/composables/useServiceAccount/useServiceAccount';

export const deliveryRoutes: RouteRecordRaw[] = [
  {
    path: '/deliveries',
    beforeEnter: [
      () => {
        const {isFulfilmentActive} = useServiceAccount();

        if (!isFulfilmentActive.value) {
          return {name: 'dashboard'};
        }

        return true;
      },
    ],
    children: [
      {
        name: 'deliveries',
        path: '',
        component: () => import('@/views/Deliveries/DeliveriesOverview/DeliveriesOverview.vue'),
        meta: {
          title: (t) => t('deliveries.deliveries'),
        },
      },
      {
        name: 'deliveries-create',
        path: 'create',
        component: () => import('@/views/Deliveries/DeliveriesCreate/DeliveriesCreate.vue'),
        meta: {
          title: (t) => t('deliveries.deliveries'),
        },
      },
      {
        name: 'deliveries-edit',
        path: ':id',
        props: true,
        component: () => import('@/views/Deliveries/DeliveriesEdit/DeliveriesEdit.vue'),
        meta: {
          title: (t) => t('deliveries.deliveries'),
        },
      },
    ],
  },
];
